import HcsButton from "./hcs-button";
import MessageBox from "../messagebox";

export default class HcsButtonGroupNext extends HcsButton {
    constructor(props) {
        super(props);

        this.changeGroup = this.changeGroup.bind(this);
    }

    // override from base class
    buttonClick() {
        // Must disable button to avoid double-click events
        this.disable();

        // We wait until (running) ECS callback has finished.
        // This is necessary because:
        // When the user enters the last required value inside a text field and immediately presses the "Next" button,
        // the blur event of the text field triggers the ECS callback, but the button "Next" event tells us that the current
        // configuration step has not yet been finished. This requires that the user has to press "Next" a second time.
        //
        // To avoid this we first wait for the text field callback, then we check if the current configuration step is ready to finish.
        // If not we show the warning message, otherwise we trigger the "Next" callback.
        this.props.configWait([ "setCfgValue", "setSubCfgValue" ], this).then(() => {
            const { data, hcs } = this.props;
            let self = this;

            if(!data.info.visible) {
                hcs.api.messageBox.show({
                    modal: true,
                    title: hcs.t.ecs("ConfigGroupLocked_Title"),
                    text: hcs.t.ecs("ConfigGroupLocked_Message"),
                    buttons: MessageBox.MB_OK,
                    messageType: MessageBox.MB_INFO
                });

                self.enable();
                return;
            }
            
            this.props.onConfig("setCfgValue", data.ident, data.values[0].ident, {
                attrChecked: true,
                sender: "BTN_NEXT",
                success: function() {
                    self.triggerConfigurator();
                    self.changeGroup("GOTO-NEXT");
                }
            });
        });
    }

    triggerConfigurator() {
        super.triggerConfigurator();
    }

    /**
     * Override from base class.
     * We always show this button whatever it's real visible state is.
     * When pressing this button is not allowed we show a warning message instead.
     * See buttonClick() function for more details.
     * @returns {boolean} This button is always visible and therefore we always return true here.
     */
    isVisible() {
        return true;
    }

    changeGroup(groupId) {
        this.props.onGroupChanged(groupId);
    }

    // override from base class
    getCcaoData() {
        const { data } = this.props;

        if(data.values && data.values[0].data.CCAO_DATA) {
            try {
                return JSON.parse(data.values[0].data.CCAO_DATA);
            } catch(e) {
                console.error(`Error parsing CCAO_DATA object from ECS for attribute '${data.ident}': ${e.message}: ${value.data.CCAO_DATA}`);
            }
        }

        return null;
    }

    // override from base class
    childClass() {
        return "hcs-button-next";
    }

    buttonClasses() {
        const { data } = this.props;

        let inputClasses = ["hcs-button", "hcs-secondary", "hcs-next"];

        if(data.info.focused) {
            inputClasses.push("hcs-focused");
        }

        return inputClasses;
    }
}